import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { formatDate } from "../utils/dateUtils";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { useSearchParams } from "react-router-dom";
import HandleError from "../utils/HandleError";
import ButtonLoader from "./ButtonLoader";
import { Environment } from "../utils/environments";
import ToastModal from "./ToastModal";
import CouponSupportType from "./CouponSupportType";

export default function CouponWrapper({ coupon, chargeData, setCouponData }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState<undefined | any>(undefined);
  const [couponError, setCouponError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCouponAvailable, setIsCouponAvailable] = useState<boolean>(false);
  const productId = searchParams.get("productId")
    ? searchParams.get("productId")
    : "";
  if (Environment.getBuildType() != "prod") {
    console.log(coupon);
  }
  useEffect(() => {
    if (isCouponAvailable) {
      var ticketWrapper: any = document.querySelector(".card-wrapper");
      var ticketWrapperOffset = ticketWrapper?.offsetTop;
      window.scrollTo({
        top: ticketWrapperOffset,
        behavior: "smooth",
      });
    }
    if (
      sessionStorage.getItem("couponCode") &&
      sessionStorage.getItem("token")
    ) {
      validateCouponCode(sessionStorage.getItem("couponCode") || "", false);
    }
  }, [isCouponAvailable]);
  function validateCoupon(coupon) {
    const couponCode = coupon.couponCode;
    // const couponInput = document.querySelector(
    //   ".couponInput"
    // ) as HTMLInputElement;
    // if (couponInput !== null) {
    //   couponInput.value = couponCode;
    //   setInputValue(couponInput.value);
    // }
    // const formBtn = document.querySelector(
    //   ".coupon-input-wrapper button"
    // ) as HTMLButtonElement;
    setLoading(true);
    setInputValue(couponCode);
    validateCouponCode(couponCode);
  }
  function checkCoupon(e) {
    e.preventDefault();
    setLoading(true);
    setCouponError(false);
    var couponCode = e.target.elements[0].value;
    if (couponCode == "") {
      setLoading(false);
      return;
    }
    if (couponCode.length < 4) {
      setCouponError(true);
      setLoading(false);
      return;
    }
    if (couponCode.includes(" ") || couponCode.includes("　")) {
      setCouponError(true);
      setLoading(false);
      return;
    }
    validateCouponCode(couponCode);
  }

  async function validateCouponCode(couponCode: string, showModal = true) {
    try {
      await httpPost({
        pathName: "coupon-valid",
        bodyParams: {
          productId: productId,
          couponCode: couponCode,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log({
            couponCode: couponCode,
            data: data,
          });
        }
        setCouponData({
          couponCode: couponCode,
          data: data,
        });
        if (data.couponAvailable == false) {
          setCouponError(true);
        } else {
          if (showModal) {
            setIsCouponAvailable(true);
          }
        }
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error.response.status >= 400 && error.response.status <= 499) {
        setCouponError(true);
      } else {
        setError(error.response.status);
      }
    } finally {
      setLoading(false);
    }
  }
  var productExists = coupon.some((item) => {
    return item.availableProductList.some((product) => {
      if (
        product.productType == "SUPPORT" &&
        chargeData.product.productType == "SUPPORT"
      ) {
        return product.minutesToSupport == chargeData.product.minutesToSupport;
      }
      return product.productType === chargeData.product.productType;
    });
  });
  console.log(productExists);
  return (
    <Fragment>
      {productExists && (
        <Box component={"section"} className="section-50" id="coupon-section">
          <Container className="container">
            <Typography className="coupon-guide-header" component="h3">
              <img src={"/images/reason04_icon.png"} alt="coupon icon" />
              <span>クーポン</span>
            </Typography>

            <Typography
              style={{
                marginTop: "1rem",
                color: "var(--text-color-2)",
                fontWeight: "600",
              }}
            >
              有効なクーポンコードがあります。クーポンコードを選択すると割引きが適用されます。
            </Typography>
            {/* <form className="coupon-input-wrapper" onSubmit={checkCoupon}>
              <Typography
                style={{
                  color: "var(--text-color-2)",
                  fontWeight: "600",
                }}
              >
                クーポンコード
              </Typography>
              <Box>
                <input
                  type="text"
                  className="couponInput"
                  maxLength={4}
                  onChange={(e) => setInputValue(e.target.value)}
                />
                {couponError && (
                  <Typography className="error-message">
                    クーポンは適用できません
                  </Typography>
                )}
              </Box>
              {loading && <div className="button-overlay"></div>}
              <button
                className="menu-btn"
                type="submit"
                disabled={
                  loading ||
                  inputValue == undefined ||
                  inputValue.length < 4 ||
                  inputValue.includes(" ")
                }
              >
                {loading ? <ButtonLoader btnColor="light" /> : "適用する"}
              </button>
            </form> */}
            {coupon && (
              <Box style={{ marginTop: "2rem" }}>
                <Grid container spacing={2}>
                  {coupon.map((item, id) => (
                    <Fragment key={id}>
                      {item.availableProductList?.map((list, idx) => {
                        if (
                          (list.minutesToSupport &&
                            list.minutesToSupport ==
                              chargeData.product.minutesToSupport) ||
                          (list.minutesToSupport == undefined &&
                            list.productType == chargeData.product.productType)
                        ) {
                          return (
                            <Grid item md={6} key={idx} sm={6} xs={12}>
                              <Box
                                className={`home-coupon-wrapper ${
                                  loading && inputValue === item.couponCode
                                    ? "coupon-loading"
                                    : ""
                                }`}
                                onClick={() => validateCoupon(item)}
                              >
                                <Grid
                                  container
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Grid
                                    item
                                    md={"auto"}
                                    container
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <Typography className="home-coupon-number">
                                      クーポンコード: {item.couponCode}
                                    </Typography>
                                    {loading &&
                                      inputValue === item.couponCode && (
                                        <div className={"coupon-loader"}></div>
                                      )}
                                  </Grid>
                                  {item.expire && (
                                    <Grid
                                      item
                                      md={"auto"}
                                      className="home-coupon-expiry"
                                    >
                                      有効期限:{" "}
                                      {formatDate(item.expire, false, "")}
                                    </Grid>
                                  )}
                                </Grid>
                                <Box>
                                  <div className="available-names">
                                    <CouponSupportType coupon={item} />
                                  </div>
                                  <Typography
                                    component={"h5"}
                                    variant="h5"
                                    className="classification-heading"
                                  >
                                    {item.couponName}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                          );
                        }
                      })}
                    </Fragment>
                  ))}
                </Grid>
              </Box>
            )}
          </Container>
        </Box>
      )}
      <HandleError errorCode={error} />
      {isCouponAvailable && (
        <ToastModal
          errorModal={isCouponAvailable}
          setErrorModal={setIsCouponAvailable}
          message={"クーポンを適用しました"}
        />
      )}
    </Fragment>
  );
}
